import React from "react";

/**
 * PaymentsTable — read-only ledger of payments (PayPal / Stripe / etc).
 * Now surfaces the gateway with an at-a-glance icon so admins can reconcile
 * across PayPal, Venmo, and Stripe without digging into the raw row.
 */
function renderGateway(p) {
  const g = (p.payment_provider || p.gateway || p.payment_gateway || "").toLowerCase();
  if (g.includes("stripe")) {
    return <span title="Stripe (card / Apple Pay / Google Pay)">💳 Stripe</span>;
  }
  if (g.startsWith("paypal")) {
    return <span title="PayPal or Venmo">🟦 PayPal/Venmo</span>;
  }
  if (g) return <span title={g}>{g}</span>;
  return <span className="text-[#E8E4DC]/60">—</span>;
}

export default function PaymentsTable({ payments }) {
  return (
    <table className="w-full" data-testid="payments-table">
      <thead className="bg-white/5">
        <tr>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Email</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Package</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Amount</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Gateway</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Status</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Date</th>
        </tr>
      </thead>
      <tbody>
        {payments.map((p) => {
          const paid = p.payment_status === "paid" || p.payment_status === "completed";
          return (
            <tr key={p.id} className="border-t border-white/10" data-testid={`payment-row-${p.id}`}>
              <td className="p-4 text-white text-sm">{p.email || "N/A"}</td>
              <td className="p-4 text-[#E8E4DC] capitalize text-sm">{p.package_id}</td>
              <td className="p-4 text-[#E8E4DC] text-sm">${p.amount}</td>
              <td className="p-4 text-[#E8E4DC] text-sm whitespace-nowrap" data-testid="payment-gateway-cell">
                {renderGateway(p)}
              </td>
              <td className={`p-4 capitalize text-sm ${paid ? "text-[#A3E635]" : "text-yellow-400"}`}>{p.payment_status}</td>
              <td className="p-4 text-[#E8E4DC] text-sm">{new Date(p.created_at).toLocaleDateString()}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
